document.addEventListener('DOMContentLoaded', function() {
  // Add your custom search phrases inside this array
  const phrases = [
    "Search for AC Remotes...",
    "Looking for Tv Remotes?",
    "Find Projector Remotes...",
    "Try 'BLDC Fan Remotes'"
  ];
  
  // Target Shopify default search inputs
  const searchInputs = document.querySelectorAll('input[type="search"], .search__input');
  
  if (searchInputs.length === 0) return;

  let phraseIndex = 0;
  let characterIndex = 0;
  let isDeleting = false;
  let currentDelay = 150; // Initial typing speed

  function typeAnimation() {
    const currentPhrase = phrases[phraseIndex];
    
    if (isDeleting) {
      // Remove characters
      characterIndex--;
      currentDelay = 50; // Faster speed when backspacing
    } else {
      // Add characters
      characterIndex++;
      currentDelay = 120; // Normal typing speed
    }

    // Update placeholder text for all matching search bars on the page
    searchInputs.forEach(input => {
      input.setAttribute('placeholder', currentPhrase.substring(0, characterIndex));
    });

    // Handle end of typing a full phrase
    if (!isDeleting && characterIndex === currentPhrase.length) {
      currentDelay = 2000; // Pause at the end of the phrase
      isDeleting = true;
    } 
    // Handle end of deleting a phrase
    else if (isDeleting && characterIndex === 0) {
      isDeleting = false;
      phraseIndex = (phraseIndex + 1) % phrases.length; // Loop back to the first phrase
      currentDelay = 500; // Pause before starting the next phrase
    }

    setTimeout(typeAnimation, currentDelay);
  }

  // Start the animation loop
  typeAnimation();
});
